import React, { useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import moment from 'moment';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { makeStyles } from  '@material-ui/core/styles';
import {
  Card,
  CardActions,
  CardContent,
  TableContainer,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TablePagination,
  Tooltip,
  Button,
  Avatar,
  Typography,
  TableSortLabel,
  Chip,
  IconButton
} from '@material-ui/core';
import { Edit, Done, DeleteForever, ArrowUpward, ArrowDownward,Visibility,VisibilityOff } from '@material-ui/icons';
import { Link } from 'react-router-dom';
import { red, green, orange, yellow } from '@material-ui/core/colors';
import { useTranslation, withTranslation } from 'react-i18next'
import DataServices from '../../service/data-services';


    const useStyles = makeStyles(theme => ({
      root: {},
      content: {
        padding: 0
      },
      inner: {
        minWidth: 750
      },
      nameContainer: {
        display: 'flex',
        alignItems: 'center'
      },
      avatar: {
        marginRight: theme.spacing(2)
      },
      actions: {
        justifyContent: 'flex-end'
      },
      table: {
        minWidth: 750
      }
    }));

    const AuditLogsTable = props => {
        const { className, contentList, defaultRowsPerPage, defaultPage, onChangePage, totalRecords, onClick, ...rest } = props;
        const classes = useStyles();

        var t = props.lang;
        var i18n = props.i18n;
        const dataService = new DataServices( );
        var auth = dataService.getAuthoritiesData( );

         const [rowsPerPage, setRowsPerPage] = useState(defaultRowsPerPage);
         const [page, setPage] = useState(defaultPage);
         const [asc, setAsc] = useState(false);
         const [orderBy, setOrderBy] = useState('id');
         const [trackingIdSort, setTrackingIdSort] = useState(false);
         const [idSort, setIdSort] = useState(true);
         const [userNameSort, setUserNameSort] = useState(false);
         const [actionSort, setActionSort] = useState(false);
         const [dropOffPersonNameSort, setDropOffPersonNameSort] = useState(false);

         const handlePageChange = (event, newPage) => {
            onChangePage(newPage, rowsPerPage, orderBy, asc );
            setPage(newPage);
        };

       const handleRowsPerPageChange = event => {
         setRowsPerPage(parseInt(event.target.value, 10));
         onChangePage( 0, parseInt(event.target.value, 10), orderBy, asc );
         setPage( defaultPage );
       };

        const handleRowClick = keyword =>{
            setOrderBy(keyword);
            setAsc(!asc);
            onChangePage( page, rowsPerPage, keyword, !asc );

            if( keyword === 'id'){
                setIdSort(true);
                setDropOffPersonNameSort(false);
                setUserNameSort(false);
                setActionSort(false);
                setTrackingIdSort(false);
            }else if( keyword === 'moduleName'){
                setIdSort(false);
                setDropOffPersonNameSort(true);
                setUserNameSort(false);
                setActionSort(false);
                setTrackingIdSort(false);
            }else if( keyword === 'usr.name'){
                setIdSort(false);
                setDropOffPersonNameSort(false);
                setUserNameSort(true);
                setActionSort(false);
                setTrackingIdSort(false);
            }else if( keyword === 'action'){
                setIdSort(false);
                setDropOffPersonNameSort(false);
                setUserNameSort(false);
                setActionSort(true);
                setTrackingIdSort(false);
            }else if( keyword === 'logType'){
                setIdSort(false);
                setDropOffPersonNameSort(false);
                setUserNameSort(false);
                setActionSort(false);
                setTrackingIdSort(true);
            }
        };

       return (
         <Card
           {...rest}
           className={clsx(classes.root, className)}
         >
           <CardContent className={classes.content}>

             <PerfectScrollbar>
               <TableContainer>
                 <Table className={classes.table} size="small">
                   <TableHead>
                     <TableRow>

                       <TableCell sortDirection={asc?'asc':'desc'} style={{whiteSpace:'nowrap'}}>
                           <TableSortLabel
                             active={idSort}
                             direction={asc?'asc':'desc'}
                             onClick={(e)=> {handleRowClick('id')}}>Date</TableSortLabel>
                       </TableCell>

                       <TableCell sortDirection={asc?'asc':'desc'} style={{whiteSpace:'nowrap'}}>
                           <TableSortLabel
                             active={dropOffPersonNameSort}
                             direction={asc?'asc':'desc'}
                             onClick={(e)=> {handleRowClick('moduleName')}}>Module name</TableSortLabel>
                       </TableCell>

                       <TableCell sortDirection={asc?'asc':'desc'} style={{whiteSpace:'nowrap'}}>
                           <TableSortLabel
                             active={userNameSort}
                             direction={asc?'asc':'desc'}
                             onClick={(e)=> {handleRowClick('usr.name')}}>User name</TableSortLabel>
                       </TableCell>
                        <TableCell sortDirection={asc?'asc':'desc'} style={{whiteSpace:'nowrap'}}>Action</TableCell>
                       {/*<TableCell sortDirection={asc?'asc':'desc'} style={{whiteSpace:'nowrap'}}>
                           <TableSortLabel
                             active={setActionSort}
                             direction={asc?'asc':'desc'}
                             onClick={(e)=> {handleRowClick('action')}}>Action</TableSortLabel>
                       </TableCell>*/}

                       <TableCell sortDirection={asc?'asc':'desc'} style={{whiteSpace:'nowrap'}}>
                           <TableSortLabel
                             active={trackingIdSort}
                             direction={asc?'asc':'desc'}
                             onClick={(e)=> {handleRowClick('logType')}}>Type</TableSortLabel>
                       </TableCell>
                       <TableCell sortDirection={asc?'asc':'desc'} style={{whiteSpace:'nowrap'}}>Detail</TableCell>
                     </TableRow>
                   </TableHead>
                   <TableBody>
                     { contentList.slice(0, rowsPerPage).map(contentItem => (
                       <TableRow
                         className={classes.tableRow}
                         hover
                         key={contentItem.guid} >

                        <TableCell style={{whiteSpace:'nowrap'}}>{ moment(contentItem.createdOn).format('DD MMM, YYYY hh:mm:ss a') }</TableCell>
                        <TableCell style={{whiteSpace:'nowrap'}}>{contentItem.moduleName}</TableCell>
                        <TableCell style={{whiteSpace:'nowrap'}}>{contentItem.userName} </TableCell>
                        <TableCell style={{whiteSpace:'nowrap'}}>{contentItem.action }</TableCell>
                         <TableCell style={{whiteSpace:'nowrap'}}>{contentItem.logType }</TableCell>
                         <TableCell>
                         <TableCell style={{whiteSpace:'nowrap'}}>{contentItem.details }</TableCell>
                              {/*<Tooltip title="View more" arrow>
                                 <IconButton aria-label="detail">
                                     <Visibility />
                                 </IconButton>
                              </Tooltip>*/}
                         </TableCell>
                       </TableRow>
                     ))}
                   </TableBody>
                 </Table>
                 </TableContainer>
               </PerfectScrollbar>

           </CardContent>
           <CardActions className={classes.actions}>
             <TablePagination
               component="div"
               count={totalRecords}
               onChangePage={handlePageChange}
               onChangeRowsPerPage={handleRowsPerPageChange}
               page={page}
               rowsPerPage={rowsPerPage}
               rowsPerPageOptions={[5, 10, 25, 50, 100]}
             />
           </CardActions>
         </Card>
       );
    };

    AuditLogsTable.propTypes = {
      className: PropTypes.string,
      contentList: PropTypes.array.isRequired,
      totalRecords: PropTypes.number,
      onChangePage: PropTypes.func,
      onClick: PropTypes.func,
      defaultRowsPerPage: PropTypes.number.isRequired,
      defaultPage: PropTypes.number.isRequired
    };

//    export default PromoCodeTable;
    export default (props) => {
        const { t, i18n } = useTranslation();
        return (<AuditLogsTable lang={t} i18n={i18n} props{... props} />)
    }